import React from 'react'
import { Checkbox } from 'element-react'

const CheckboxSG = () => {
    // Constructors
    const checkList = ['Option A', 'Selected and disabled']
    const cities = ['Shanghai', 'Beijing', 'Guangzhou', 'Shenzhen']
    const checkboxGroup1 = ['Shanghai']

    return (
        <div>
            {/* Checkbox Group ============================  */}
            <h4 className="sg-heading">Checkbox Group</h4>
            <Checkbox.Group options={checkList}>
                <Checkbox label="Option A"></Checkbox>
                <Checkbox label="Option B"></Checkbox>
                <Checkbox label="Option C"></Checkbox>
                <Checkbox label="Disabled" disabled></Checkbox>
                <Checkbox label="Selected and disabled" disabled></Checkbox>
            </Checkbox.Group>

            {/* Checkbox Button Group ============================  */}
            <h4 className="sg-heading">Checkbox Button Group</h4>
            <Checkbox.Group value={checkboxGroup1}>
                {cities.map((city, index) => {
                    return (
                        <Checkbox.Button key={index} label={city}>
                            {city}
                        </Checkbox.Button>
                    )
                })}
            </Checkbox.Group>
        </div>
    )
}

export default CheckboxSG
